import AgencyHelper from 'features/Agency/agencyHelper';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import AppConstants from 'general/constants/AppConstants';
import _ from 'lodash';
import PropTypes from 'prop-types';

MaintainerListFilterView.propTypes = {
    setFilterDropdown: PropTypes.func,
    filterDropdown: PropTypes.object,
    areaProvinceOptions: PropTypes.array,
    areaDistrictOptions: PropTypes.array,
    selectedAreaDistrict: PropTypes.object,
    setSelectedAreaDistrict: PropTypes.func,
    selectedAreaProvince: PropTypes.object,
    setSelectedAreaProvince: PropTypes.func,
    areaProvinceList: PropTypes.array,
    areaDistrictList: PropTypes.array,
};

function MaintainerListFilterView({
    setFilterDropdown,
    filterDropdown,
    areaProvinceOptions,
    areaDistrictOptions,
    selectedAreaDistrict,
    setSelectedAreaDistrict,
    selectedAreaProvince,
    setSelectedAreaProvince,
    areaProvinceList,
    areaDistrictList,
}) {
    // MARK: ---- PROPERTIES ----

    // MARK: ---- METHODS ----

    return (
        <div>
            <div className={`${'col-12 p-0'}`}>
                <KTFormSearch
                    name="search-bar"
                    placeholder='Theo mã KTV, tên KTV, số điện thoại, email, MST/CCCD...'
                    value={filterDropdown.q}
                    onSubmit={(text) => {
                        const updateFilterDropdown = { ...filterDropdown, q: text };
                        setFilterDropdown(updateFilterDropdown);
                    }}
                />
            </div>
            <div className='row d-flex flex-row flex-wrap'>
                {/* loai KTV */}
                <KTDropdownFilter
                    label='Loại KTV'
                    filterKey="type"
                    options={[
                        { name: 'Tất cả', value: '' },
                        ...MaintainerHelper.Data.maintainerTypeOptions
                    ]}
                    selectedValue={filterDropdown.type}
                    additionalClassName='col-md-6 py-2 pr-2'
                    handleChange={(value) => {
                        setFilterDropdown({ ...filterDropdown, type: value });
                    }}
                />
                {/* trang thai */}
                <KTDropdownFilter
                    label='Trạng thái'
                    filterKey="status"
                    options={[
                        { name: 'Tất cả', value: '' },
                        ...MaintainerHelper.Data.maintainerStatusOptions
                    ]}
                    selectedValue={
                        filterDropdown.status ||
                        (MaintainerHelper.Filter.maintainerList.hasSignedContract || filterDropdown.hasSignedContract
                            ? AppConstants.agencyStatus.signed
                            : '')
                    }
                    additionalClassName='col-md-6 pl-2'
                    handleChange={(value) => {
                        const isSigned = value === 'SIGNED';
                        const newStatus = isSigned ? '' : value;
                        const newHasSignedContract = isSigned ? 1 : '';

                        setFilterDropdown({
                            ...filterDropdown,
                            status: newStatus,
                            hasSignedContract: newHasSignedContract,
                        });
                    }}
                />

                {/* nguoi tao */}
                <KTDropdownFilter
                    label='Người tạo'
                    filterKey="createdBy"
                    options={[
                        { name: 'Tất cả', value: '' },
                        ...MaintainerHelper.Data.maintainerCreatedByOptions
                    ]}
                    selectedValue={filterDropdown.createdBy}
                    additionalClassName='col-md-6 pr-2'
                    handleChange={(value) => {
                        setFilterDropdown({ ...filterDropdown, createdBy: value });
                    }}
                />

                {/* quoc gia */}
                <KTDropdownFilter
                    label='Quốc gia'
                    filterKey="country"
                    options={AgencyHelper.Data.CountryOptions}
                    selectedValue={filterDropdown.country}
                    additionalClassName="col-md-6 pl-2"
                    handleChange={(value) => {
                        setSelectedAreaProvince('');
                        setSelectedAreaDistrict('');
                        setFilterDropdown({ ...filterDropdown, country: value, areaId: '' });
                    }}
                />

                {/* tinh/thanh pho */}
                <KTDropdownFilter
                    label='Tỉnh/Thành phố'
                    filterKey="areaId"
                    options={areaProvinceOptions}
                    selectedOption={selectedAreaProvince}
                    selectedValue={filterDropdown.areaId}
                    additionalClassName='col-md-6 pr-2'
                    searchable={true}
                    handleChange={(value) => {
                        const province = _.find(areaProvinceList, (item) => item.areaId === value);
                        setSelectedAreaProvince(province);
                        setSelectedAreaDistrict('');
                        setFilterDropdown({ ...filterDropdown, areaId: value });
                    }}
                    disabled={filterDropdown.country !== 'VN'}
                />

                {/* phuong/xa */}
                <KTDropdownFilter
                    label='Phường/Xã'
                    filterKey="areaId"
                    options={areaDistrictOptions}
                    selectedOption={selectedAreaDistrict}
                    selectedValue={filterDropdown.areaId}
                    additionalClassName="col-md-6 pl-2"
                    searchable={true}
                    handleChange={(value) => {
                        setSelectedAreaDistrict(_.find(areaDistrictList, (item) => item.areaId === value));
                        setFilterDropdown({ ...filterDropdown, areaId: value });
                    }}
                    disabled={filterDropdown.country !== 'VN'}
                />

                {/* khoang thoi gian thong ke */}
                <div className="col-12 py-2">
                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                        Khoảng thời gian thống kê
                    </label>
                    <CustomDateRangePicker
                        toggleElementBorderRadius={5}
                        alignRight={true}
                        initialValue={
                            filterDropdown.selectedValue?.length > 0
                                ? filterDropdown.selectedValue
                                : dateFilter.tatCaThoiGian
                        }
                        onPressSave={(selectedValue, startDate, endDate) => {
                            const updateFilterDropdown = {
                                ...filterDropdown,
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default MaintainerListFilterView;
